import {
    DocumentTypeELynkPacketAddMode,
    DocumentTypeELynkPacketChecklistMode
} from '../../models/document';

export class DocumentType {
    id: number;
    type: string;
    description: string;
    active: boolean;
    version: string;
    showInUI: boolean;
    showInClassification?: boolean;
    metadata: DocumentTypeMetadata;
    constructor() {
        this.id = 0;
        this.metadata = new DocumentTypeMetadata();
    }
}

export class DocumentTypeTreeNode {
    id: number;
    type: string;
    description: string;
    version: string;
    category?: string;
}

export class DocumentTypeMetadata {
    category?: string;
    elynk?: MetedataELynk;
    templateManager?: DocumentTypeTemplateManager;
    classification?: DocumentTypeDocumentClassification;
}

export class MetedataELynk {
    packets: ELynkPacket[];
    constructor() {
        this.packets = [];
    }
}

export class ELynkPacket {
    id: string;
    add?: ELynkPacketAdd;
    checklist?: ELynkPacketChecklist;

    constructor(){
        this.id = "";
        this.checklist = null;
        this.add = null;
    }
}

export interface IELynkPacket {
    id: string;
    add?: ELynkPacketAdd;
    checklist?: ELynkPacketChecklist;

}

export class ELynkPacketChecklist {
    categoryId?: string;
    mode?: DocumentTypeELynkPacketChecklistMode;
    editable?: boolean ;
    constructor () {
        this.categoryId = '';
        this.mode = null;
        this.editable = null;
    }
}

export class ELynkPacketAdd {
    visible: DocumentTypeELynkPacketAddMode = DocumentTypeELynkPacketAddMode.Hidden;
    editable: boolean = false;
    constructor () {
        this.visible = null;
        this.editable = null;
    }
}

export class DocumentTypeTemplateManager {
    visible: boolean;
}

export class DocumentTypeDocumentClassification {
    scanning?: DocumentClassificationScanning;
    upload?: DocumentClassificationUpload;
    constructor() {
        this.scanning = new DocumentClassificationScanning();
        this.upload = new DocumentClassificationUpload();
    }
}

export class DocumentClassificationScanning {
    visible: boolean;
}

export class DocumentClassificationUpload {
    visible: boolean;
}


export class DocumentTypeFunctionalAreasSelected {
    elynk: boolean = false;
    templateManager: boolean = false;
    documentClassification: boolean = false;
}
